import { EntityRepository, Repository } from "typeorm";
import { SaleOrderLog } from "../so-log.entity";

@EntityRepository(SaleOrderLog)
export class SoLogRepository extends Repository<SaleOrderLog>{


}
